import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "brands-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = { class: "brands-container" }
const _hoisted_6 = { class: "brands-grid" }
const _hoisted_7 = { class: "brand-logo-container" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "featured-badge"
}
const _hoisted_10 = {
  key: 0,
  class: "brand-info"
}
const _hoisted_11 = { class: "brand-name" }
const _hoisted_12 = { class: "brand-desc" }
const _hoisted_13 = { class: "brand-stats" }
const _hoisted_14 = { class: "stat" }
const _hoisted_15 = { class: "stat-number" }
const _hoisted_16 = { class: "stat" }
const _hoisted_17 = { class: "stat-number" }
const _hoisted_18 = { class: "section-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('home.trustedBrands')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.brands, (brand, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: brand.id,
              class: _normalizeClass(["brand-card", { 'featured': brand.featured }]),
              style: _normalizeStyle({ animationDelay: `${index * 0.1}s` })
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: brand.logo,
                  alt: brand.name,
                  class: "brand-logo",
                  loading: "lazy",
                  onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleImageError && $setup.handleImageError(...args)))
                }, null, 40, _hoisted_8),
                (brand.featured)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_van_icon, { name: "fire" }),
                      _cache[1] || (_cache[1] = _createTextVNode(" 推荐品牌 ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (brand.featured)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("h3", _hoisted_11, _toDisplayString(brand.name), 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(brand.description), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(brand.productCount) + "+ ", 1),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-label" }, " 产品 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(brand.verificationCount) + "+ ", 1),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-label" }, " 验证 ", -1))
                      ])
                    ]),
                    _createVNode(_component_van_button, {
                      size: "small",
                      class: "brand-button",
                      onClick: ($event: any) => ($setup.handleBrandClick(brand))
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" 了解更多 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 6))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_van_button, {
          type: "primary",
          size: "large",
          class: "view-all-button",
          onClick: $setup.goToBrandsPage
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('home.viewAllBrands')) + " ", 1),
            _createVNode(_component_van_icon, {
              name: "arrow",
              class: "button-arrow"
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}